<template>
    <div id="form-send">
        <div :class="`form-send start-align-${localAlign}`">
            <button>{{ localLabel }}</button>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "FormSend",
    props: {
        label: String,
        align: String,
        item: Object,
    },
    data() {
        return {
            localLabel: this.label || "Gönder",
            localAlign: this.align,
        };
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        updateField() {
            const updateFields = {
                label: this.localLabel,
                sendButton: {
                    label: this.localLabel,
                    align: this.localAlign,
                },
            };
            this.updateFormField({
                siteId: this.item.siteId,
                formFieldId: this.item._id,
                updateFields: updateFields,
            });
            this.$emit("update-field", updateFields);
        },
    },
    watch: {
        label(newVal) {
            this.localLabel = newVal;
            this.updateField();
        },
        align(newVal) {
            this.localAlign = newVal;
            this.updateField();
        },
    },
    mounted() {
        this.localLabel = this.label || "Gönder";
        this.localAlign = this.align || "center";
    },
};
</script>

<style scoped lang="scss">
#form-send {
    .start-align-left {
        justify-content: flex-start !important;
    }

    .start-align-right {
        justify-content: flex-end !important;
    }

    .start-align-top {
        justify-content: center !important;
    }

    .form-send {
        cursor: all-scroll;
        display: flex;
        margin-top: 20px;

        button {
            background-color: #4caf50;
            color: white;
            padding: 15px 32px;
            text-align: center;
            text-decoration: none;
            display: inline-block;
            font-size: 16px;
            margin: 4px 2px;
            cursor: pointer;
            border: none;
            border-radius: 5px;
            transition: background-color 0.3s ease;

            &:hover {
                background-color: #45a049;
            }
        }
    }
}
</style>
